import tw from "twin.macro"
import dynamic from "next/dynamic"

import API from "lib/api"
import withSSRUser from "lib/withSSRUser"
import checkPageDataAuth from "lib/checkPageDataAuth"

import Zone, { experienceQuery as query } from "components/dynamic/Zone"

import { MetaFields } from "components/Metadata"

const HeroExperience = dynamic(import("components/Heroes/HeroExperience"))

export default function ExperiencePage({ pageData }) {
  const { Hero, DynamicZone, experience } = pageData
  return (
    <>
      {Hero && <HeroExperience {...Hero} experience={experience} />}
      {DynamicZone && <Zone DynamicZone={DynamicZone || []} />}
    </>
  )
}

export const getServerSideProps = withSSRUser(async ({ params }) => {
  const { HeroExperienceQuery } = await import(
    "components/Heroes/HeroExperience"
  )
  const [{ data: theme }, { data: nav }] = await Promise.all([
    API.cachedGet("/theme", 60000),
    API.cachedGet("/navigation", 60000),
  ])
  const dataFields = `{ 
      UID
      ${MetaFields}
      Hero ${HeroExperienceQuery.fields}
      DynamicZone ${query.query}
    }`
  const experienceFields = `{ 
      Name
      UID
      id
      PhoneNumber
      Email
      Website
      Address
      Cost
      Location {
        id
        Name
      }
    }`

  try {
    const [localPageData, externalPageData] = await Promise.allSettled([
      new Promise((resolve, reject) => {
        Promise.all([
          API.gql(
            `{
          experiencePages(where: { UID: "${params.experience}" }) 
            ${dataFields}
          }`,
            query.fragments
          )
            .then(({ data }) => data)
            .catch((e) => {
              console.log(e)
              return e
            }),
          API.gql(
            `
        {
          experiencePages(where: { UID: "${params.experience}" }) 
            ${experienceFields}
        }`
          ).then(({ data }) => data),
        ])
          .then(([data, experienceData]) => {
            const pageData = data?.data?.experiencePages?.[0] || {}
            const experience = experienceData?.data?.experiencePages?.[0]
            if (!pageData?.UID || !experience) {
              throw data || "No Data on local"
            }
            resolve({
              ...pageData,
              experience,
            })
          })
          .catch(reject)
      }),
      new Promise((resolve, reject) => {
        Promise.all([
          API.gql(
            `{
          Experience(UID:"${params.experience}") 
            ${dataFields}
          }`,
            query.fragments
          ).then(({ data }) => data),
          API.gql(
            `
        {
          Experience(UID:"${params.experience}") 
            ${experienceFields}
        }`
          ).then(({ data }) => data),
        ])
          .then(([data, experienceData]) => {
            const pageData = data?.data?.Experience || {}
            resolve({
              ...pageData,
              experience: experienceData?.data?.Experience,
            })
          })
          .catch(reject)
      }),
    ])

    const pageData: any = ("value" in localPageData && localPageData?.value) ||
      ("value" in externalPageData && externalPageData?.value) || { UID: null }
    if ("reason" in localPageData) {
      const authRedirect = checkPageDataAuth(
        localPageData?.reason,
        `experience/${params.experience}`
      )
      if (authRedirect) {
        return authRedirect
      }
    }
    return {
      notFound: !("UID" in pageData) || !pageData?.UID,
      props: {
        theme,
        nav,
        pageData: {
          ...pageData,
        },
      },
    }
  } catch (e) {
    console.warn(`Error fetching props for experience ${params.experience}`, e)
    return {
      notFound: true,
    }
  }
})
